import { routineCsvHeaders } from 'common/constants/routineCsvHeader';
import Papa from 'papaparse';

const _prefix = 'condition';
const _numberHeaders = [
  'id',
  'workout_id',
  'date',
  'count',
  'set_count',
  'weight_multiplier',
];

/**
 * CSV 데이터를 파일로 내보내는 함수
 * @param data - 2차원 배열 형태의 CSV 데이터 (헤더 포함)
 * @param fileName - 저장할 파일 이름 (확장자 제외)
 */
export const exportToCSV = (data: any[][], fileName: string): void => {
  // Papa.unparse를 사용하여 2D 배열을 CSV 문자열로 변환
  const csv = Papa.unparse(data);
  
  // Blob 객체 생성
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  
  // IE 브라우저 지원 (타입스크립트 오류 제거)
  const nav: any = navigator;
  if (nav.msSaveBlob) {
    nav.msSaveBlob(blob, `${fileName}.csv`);
    return;
  }

  // a 태그를 사용하여 다운로드 링크 생성
  const link = document.createElement('a');
  
  // 브라우저에서 URL.createObjectURL 지원 확인
  if (URL && 'createObjectURL' in URL) {
    const csvUrl = URL.createObjectURL(blob);
    link.href = csvUrl;
    link.download = `${fileName}.csv`;
    link.click();
    
    // 메모리 누수 방지를 위해 URL 객체 해제
    setTimeout(() => {
      URL.revokeObjectURL(csvUrl);
    }, 100);
  }
};

export const csvToJson = (
  csv: string | ArrayBuffer | null,
  challengeId: string,
): IChallengeRoutines[] => {
  if (!csv || typeof csv !== 'string') {
    return [];
  }

  const getHeaderKey = (label: string) =>
    routineCsvHeaders.filter((item) => item.label === label)[0]?.key;

  const parseResult = Papa.parse(csv, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => getHeaderKey(header.trim()),
  });

  const result = parseResult.data.map((row: any, idx: number) => {
    const processed: any = {};

    Object.entries(row).forEach(
      ([header, value]: [header: any, value: any]) => {
        if (header === 'alt_workouts' && value) {
          processed[header] = String(value)
            .split('-')
            .map((v) => Number(v.trim()));
          return;
        }

        if (header === 'alt_workouts_part') {
          processed[header] = value ? Number(value) : null;
          return;
        }
        if (header === 'ChallengeId') {
          processed[header] = challengeId;
          return;
        }

        if (header?.includes(_prefix)) {
          if (header === 'condition_id') {
            processed.challenge_id = value ? +value : null;
          }

          const headerName = header.replace(`${_prefix}_`, '');
          processed.challenge_condition = {
            ...processed.challenge_condition,
            // eslint-disable-next-line no-nested-ternary
            [headerName]: _numberHeaders.includes(headerName)
              ? value
                ? +value
                : 0
              : value,
          };
        } else {
          let processedValue: string | number = value;

          if (_numberHeaders.includes(header)) {
            if (header === 'id' && !value) {
              processedValue = `new-default-row-${idx}`;
            } else {
              processedValue = value ? +value : 0;
            }
          }

          processed[header] = processedValue;
        }
      },
    );

    return processed;
  });

  return result;
};
